import React from 'react';
import VirtualMirror from './VirtualMirror';
import { ContextContainer } from './context';
import ProductRange from '../../pages/Discover/ProductRange';
import ShopNow from '../showNow';
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { isIFRAMEUrl, defineTypeCase } from 'Root/utils';

export default ({ ...props }) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'meta.title.vm', defaultMessage: '1-DAY ACUVUE® DEFINE®' });
  const description = intl.formatMessage({ id: 'meta.desc.vm', defaultMessage: 'Science, art and technology-backed daily disposable lenses crafted for the best of beauty, comfort and health.' });
  return (
    <ContextContainer>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <main>
        <VirtualMirror {...props} />
        
        { isIFRAMEUrl() === false ? <ProductRange /> : null}
        { isIFRAMEUrl() === false ? <ShopNow /> : null}
      </main>
    </ContextContainer>
  );
};
